import {createRouter, createWebHistory} from "vue-router";
import TestemunhoDetalhe from "@/containers/testemunhoDetalhe.vue";
import TestemunhosOverview from "@/containers/testemunhosOverview.vue";

let baseUrl = window.currentLanguage == "en" ?
    import.meta.env.VITE_APP_BASEURLEN : import.meta.env.VITE_APP_BASEURL;

const router = createRouter({
    routes:[
        {
            path:'/:id',
            component: TestemunhoDetalhe,
            name: "detalhe",
            props: true },
        {
            path:'/',
            name:"home",
            component: TestemunhosOverview,
            props: true
        }
    ],
    history: createWebHistory(baseUrl),
    scrollBehavior() { return { top: 0 }  },
});

export default router;